export default [
    {
        path: "/country/notice",
        props: true,
        component: () => import("@/views/Country/Notice"),
    },
];
